import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  buttonLink: {
    marginRight: 24,
    maxHeight: 40,
    minHeight: 40,
    textTransform: 'none',
  },
  filterBackground: {
    background: '#ECEAEA',
  },
  selectOption: {
    width: '100%',
  },
  dataSelect: {
    width: '100%',
    minWidth: 250,
    border: '1px solid',
    boxShadow: '0',
    background: 'white',
    borderRadius: 5,
  },
  btnPicky: {
    maxHeight: 40,
    minHeight: 40,
    color: 'black',
    borderRadius: 5,
  },
  selectPicky: {
    marginLeft: 32,
    marginRight: 16,
  },
  titleStyle: {
    margin: theme.spacing(4, 4, 3, 4),
  },
  loadingStyle: {
    marginTop: 35,
  },
  selectSpan: {
    margin: (0, 5, 10, 5),
  },
  selectPropsBG: {
    background: 'white',
  },
}))

export default useStyles
